// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import React from 'react';

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { View } from 'app/scripts/views/internal/view';
import { Dialog } from 'app/scripts/views/lib/Dialog';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PopoverConfirmationPublicBoardsTemplate } from 'app/scripts/views/templates/PopoverConfirmationPublicBoardsTemplate';
import {
  dialogProps,
  LazyBoardInviteModal,
} from 'app/src/components/BoardInviteModal';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

interface ConfirmationPublicBoardsView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setTimeout: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class ConfirmationPublicBoardsView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Co... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'change to public';

    // @ts-expect-error TS(2339): Property 'className' does not exist on type 'Confi... Remove this comment to see the full error message
    this.prototype.className = 'confirmation-popover';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'Confirma... Remove this comment to see the full error message
    this.prototype.events = {
      'click .js-submit': 'selectVis',
      'click .js-action-link': 'renderInvitationLink',

      'mouseenter .js-action-link': 'mouseenter',
      'mouseleave .js-action-link': 'mouseleave',
    };
  }

  render() {
    const data = this.model.toJSON();
    data.isTemplate = this.model.isTemplate();

    this.$el.html(PopoverConfirmationPublicBoardsTemplate(data));

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectVis(e: any) {
    stopPropagationAndPreventDefault(e);

    const traceId = Analytics.startTask({
      taskName: 'edit-board/prefs/permissionLevel',
      source: 'makeBoardPublicInlineDialog',
    });

    const change = this.model.getPref('permissionLevel') !== 'public' ? 1 : 0;

    this.model.setPrefWithTracing('permissionLevel', 'public', {
      taskName: 'edit-board/prefs/permissionLevel',
      source: 'makeBoardPublicInlineDialog',
      traceId,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      next: (_err: any, res: any) => {
        if (res) {
          Analytics.sendUpdatedBoardFieldEvent({
            field: 'visibility',
            value: 'public',
            source: 'makeBoardPublicInlineDialog',
            containers: {
              board: {
                id: this.model.id,
              },
              organization: {
                id: this.model.getOrganization()?.id,
              },
              enterprise: {
                id: this.model.getEnterprise()?.id,
              },
            },
            attributes: {
              change,
              taskId: traceId,
            },
          });
        }
      },
    });

    this.model.save();

    return PopOver.hide();
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  renderInvitationLink(e: any) {
    stopPropagationAndPreventDefault(e);

    Dialog.show({
      reactElement: (
        <ComponentWrapper>
          <LazyBoardInviteModal
            idBoard={this.model.id}
            idOrg={this.model.getOrganization()?.id}
            onClose={Dialog.hide}
          />
        </ComponentWrapper>
      ),
      ...dialogProps,
    });
    $('.board-share-button').removeClass('open-manage-boards-offset');

    Analytics.sendClickedLinkEvent({
      // @ts-expect-error TS(2322): Type '"openShareMenuLink"' is not assignable to ty... Remove this comment to see the full error message
      linkName: 'openShareMenuLink',
      source: 'changeBoardVisiblityToPublicConfirmationInlineDialog',
      containers: {
        board: {
          id: this.model.id,
        },
        organization: {
          id: this.model.getOrganization()?.id,
        },
        enterprise: {
          id: this.model.getEnterprise()?.id,
        },
      },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseenter(e: any) {
    return $('.board-share-button').addClass('open-manage-boards-offset');
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mouseleave(e: any) {
    return this.setTimeout(
      () => $('.board-share-button').removeClass('open-manage-boards-offset'),
      0,
    );
  }
}

ConfirmationPublicBoardsView.initClass();
export { ConfirmationPublicBoardsView };
